export enum LoanApiUrls {
  Loans = "/v1/Loans",
  LoanTransactions = "/v1/Loans/:id/Transactions",
  LoanSchedule = "/v1/Loans/:id/Schedule",
  LoanStatement = "/v1/Loans/:id/Statements",
  LoanStatementExport = "/v1/Loans/:id/Statements/Export",
}

export enum LoanType {
  Standard = "Standard",
  CreditLine = "CreditLine",
  Overdraft = "Overdraft",
  Leasing = "Leasing",
  Factoring = "Factoring",
}
